import api from "utils/api";

const toUrlMap = (data: unknown): Record<string, string | null> | null => {
  if (typeof data !== "object" || data === null) return null;
  if (!("urls" in data)) return null;

  const { urls } = data;
  if (typeof urls !== "object" || urls === null) return null;

  const urlMap: Record<string, string | null> = {};
  for (const [key, value] of Object.entries(urls)) {
    urlMap[key] = typeof value === "string" ? value : null;
  }
  return urlMap;
};

// Folder-internal. null = the request failed or answered garbage (do not cache).
export const requestSignedUrls = async (
  projectId: string,
  keys: string[],
): Promise<Record<string, string | null> | null> => {
  try {
    const data: unknown = await api.getProjectAssetUrls(projectId, keys);
    return toUrlMap(data);
  } catch {
    return null;
  }
};
